import React, {FC} from "react"
import './Input.less'

interface Props {
    id: string
    label: string
    value: string
    minValue: number
    maxValue: number
    setValue: (value: string) => void
    onConfirm: () => void
    onCancel: () => void
}

export const InputNumber: FC<Props> = ({
                                     id,
                                     label,
                                     value,
                                     minValue,
                                     maxValue,
                                     setValue,
                                     onConfirm,
                                     onCancel,
                                 }) => {
    const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
    }
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Escape') {
            onCancel()
        } else if (e.key === 'Enter' || e.key === 'NumpadEnter') {
            onConfirm()
        }
    }

    return (
        <div className="form-input-container">
            <label htmlFor={id} className="label">{label}:</label>
            <input
                id={id}
                type="number"
                className="input"
                value={value}
                min={minValue}
                max={maxValue}
                onChange={handleChangeValue}
                onKeyDown={handleKeyDown}
            />
        </div>
    )
}
